import { ShoppingCartOutlined, SolutionOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const PurchasesPage = lazyRouteComponent(() => import('./pages/purchases'));

const SalesPage = lazyRouteComponent(() => import('./pages/sales'));
const OrderDetailsPage = lazyRouteComponent(() => import('./pages/details'));
const AdminOrdersPage = lazyRouteComponent(() => import('./pages/admin-list'));

export const getRoutes = (): Route[] => [
  {
    page: AdminOrdersPage,
    path: ROUTE_PATHS.ADMIN_ORDERS,
    title: 'Pedidos',
    icon: SolutionOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'finance',
    adminOrder: 10,
  },
  {
    page: PurchasesPage,
    path: ROUTE_PATHS.PURCHASES,
    title: 'Minhas compras',
    icon: ShoppingCartOutlined,
  },
  {
    page: OrderDetailsPage,
    path: ROUTE_PATHS.ADMIN_ORDER_DETAILS,
    title: 'Detalhes do pedido',
    hidden: true,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: SalesPage,
    path: ROUTE_PATHS.STORE_SALES,
    title: 'Minhas vendas',
    hidden: true,
  },
  {
    page: OrderDetailsPage,
    path: ROUTE_PATHS.PURCHASE_DETAILS,
    title: 'Detalhes da compra',
    hidden: true,
  },
  {
    page: OrderDetailsPage,
    path: ROUTE_PATHS.SALE_DETAILS,
    title: 'Detalhes da venda',
    hidden: true,
  },
];
